/** Who owns a sticker: an organization (any of its admins hosts it) or a user. */
export interface StickerOwner {
  entity?: string | null;
  entityId?: string | null;
  organization?: { id?: string | null } | null;
  user?: { id?: string | null } | null;
}

/** Whether the user `meId`, admin of `myOrgIds`, hosts the sticker. */
export function isStickerHost(
  sticker: StickerOwner | null | undefined,
  meId: string | null | undefined,
  myOrgIds: Array<string | null | undefined>,
): boolean {
  if (!sticker || !meId) return false;
  if (sticker.entity === 'Organization') {
    const orgIds = new Set(myOrgIds.filter(Boolean).map(String));
    return [sticker.entityId, sticker.organization?.id]
      .some((id) => id != null && orgIds.has(String(id)));
  }
  return String(meId) === String(sticker.user?.id ?? '');
}

/**
 * Whether `findOrganizationsV2` returns organizations the caller manages. The backend limits it to
 * the caller's own organizations for ORG accounts (and gives ADMIN every one); for a plain USER it
 * returns every approved organization, so a USER manages none (SPO-1207).
 */
export function listsManagedOrganizations(usertype: string | null | undefined): boolean {
  return String(usertype ?? '').toUpperCase() !== 'USER';
}
